module.exports = __webpack_public_path__ + "static/img/toutiao.d93f6227.png";